import { usePermissions } from '@/composables/usePermissions'

/**
 * Access to the Developer group: Import Log Inspector, VESPROC Callback Errors
 * and Webhook Management. These are engineering diagnostics — raw import payloads,
 * failed callbacks, webhook delivery logs — and are noise (or worse, confusing) for
 * a non-technical super admin such as a CFO who only needs the dashboard and billing.
 *
 * Historically all three were gated on Supplier.SuperAdmin.Dashboard, which is also
 * what grants the dashboard itself, so anyone who could see the dashboard got the
 * technical tools too. Supplier.SuperAdmin.Developer now separates the two, and the
 * backend enforces it on every matching endpoint (SuperAdminWebhookController,
 * SuperAdminController's import-log/callback actions and their app services), so this
 * check mirrors the server rather than merely hiding menu entries.
 *
 * The permission is granted to existing super admins by SuperAdminRoleSeedContributor,
 * which iterates SupplierPermissions.SuperAdmin.All; anyone else gets it from the
 * Manage Access screen.
 */
const DEVELOPER_PERMISSION = 'Supplier.SuperAdmin.Developer'

export function useDeveloperPermissions() {
  const { hasPermission } = usePermissions()

  const canAccessDeveloperTools = () => hasPermission(DEVELOPER_PERMISSION)

  return {
    canAccessDeveloperTools,
    DEVELOPER_PERMISSION
  }
}
